import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import { deleteGalleryPlanAPI } from "../../../../utils/APIs/galleryPlansApis";
import { deletePhotographyPlanAPI } from "../../../../utils/APIs/photographyPlansApis";
import { deleteEditingPlanAPI } from "../../../../utils/APIs/editingPlansApis";
import Loader from "../../../../Template/Loader/Loader";
import { toast } from "react-toastify";

const DeleteGalleryPlanModal = ({ show, onClose, plan, refreshData, activeTab }) => {
  const [loading, setLoading] = useState(false);

  const handleDelete = async () => {
    if (!plan?._id) return;

    try {
      setLoading(true);
      let res;

      if (activeTab === "gallery") {
        res = await deleteGalleryPlanAPI(plan._id);
      } else if (activeTab === "hourly") {
        res = await deletePhotographyPlanAPI(plan._id);
      } else if (activeTab === "editing") {
        res = await deleteEditingPlanAPI(plan._id);
      }

      if (res?.data?.success) {
        refreshData();
        onClose();
        toast.success(res?.data?.message || "Plan deleted successfully");
      } else {
        toast.error(res?.data?.message || "Failed to delete plan");
      }
    } catch (error) {
      console.error("Delete failed:", error);
      toast.error(error?.response?.data?.message || "Something went wrong while deleting");
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <Loader />;
  }

  return (
    <Modal show={show} onHide={onClose} centered>
      <div className="custom-modal">
        <h4>Delete {activeTab?.charAt(0).toUpperCase() + activeTab?.slice(1)} Plan</h4>

        <p>
          Are you sure you want to delete this plan?
        </p>

        <div className="modal-actions">
          <button className="btn-cancel" onClick={onClose}>
            Cancel
          </button>
          <button className="btn-delete" onClick={handleDelete}>
            Delete
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default DeleteGalleryPlanModal;